import React, { useState } from 'react';
import styled from 'styled-components';
import PopoverFiltroBasico from '../../../PopoverFiltroBasico';
import { cores } from '../../../../styles/styleUtils';

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap; // Allow buttons to wrap on smaller screens
  gap: 15px;
  margin-bottom: 10px; // Add some space below the header
`;

const Title = styled.h1`
  font-size: 2rem;
  color: ${cores.chumbo};
  margin: 0;
`;

const ButtonsContainer = styled.div`
  display: flex;
  gap: 15px;
  flex-wrap: wrap; // Allow button wrapping
`;

const ActionButton = styled.button`
  background-color: ${cores.laranja};
  color: ${cores.textoClaro};
  border: none;
  padding: 10px 20px;
  border-radius: 20px; // Rounded corners
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: ${cores.laranjaEscuro};
  }
`;

const dataAtual = new Date();
const primeiroDiaDoMes = new Date(dataAtual.getFullYear(), dataAtual.getMonth(), 1);
const ultimoDiaDoMes = new Date(dataAtual.getFullYear(), dataAtual.getMonth() + 1, 0);
const emptyFiltro = {
  datainicial: primeiroDiaDoMes,
  datafinal: ultimoDiaDoMes,
};

function HeaderSection({ title, filtro, setFiltro, onLimparFiltro }) {
  const [openFiltro, setOpenFiltro] = useState(null);

  const handleNewSale = (event) => {
    setOpenFiltro(event.currentTarget);
  };

  const onCloseFiltro = () => {
    setOpenFiltro(null);
  };

  const onConfirmFiltro = (newFiltro) => {
    setFiltro(newFiltro);
    setOpenFiltro(null);
  };

  const limparFiltro = () => {
    setFiltro(emptyFiltro);
    setOpenFiltro(null);
  };

  return (
    <>
      <HeaderContainer>
        <Title>{title}</Title>
        <ButtonsContainer>
          <ActionButton onClick={handleNewSale}>Filtro</ActionButton>
        </ButtonsContainer>
      </HeaderContainer>
      {openFiltro && (
        <PopoverFiltroBasico
          filtro={filtro}
          open={openFiltro}
          onClose={onCloseFiltro}
          onLimpar={limparFiltro}
          onConfirm={onConfirmFiltro}
          type={'dashboard'}
        />
      )}
    </>
  );
}

export default HeaderSection;